import { render, staticRenderFns } from "./TCategoryContent.vue?vue&type=template&id=d4e615f0&"
import script from "./TCategoryContent.vue?vue&type=script&lang=js&"
export * from "./TCategoryContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports